import React from 'react';
import Overlay from 'src/components/ui/Overlay/Overlay';
import { OverlayRouteProvider } from 'src/providers/OverlayProvider';
import OverlayHead from '../../ui/Overlay/OverlayHead';

type Props = {
  children: React.ReactNode;
  title?: string;
  isExtended?: boolean;
};
export const RouteOverlay = ({ children, title, isExtended }: Props) => {
  return (
    <OverlayRouteProvider>
      <Overlay>
        {!isExtended && <OverlayHead title={title} />}
        {children}
      </Overlay>
    </OverlayRouteProvider>
  );
};
